/*options*/
/*--port*/
/*--no-open*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "devtools",
  "description": "`turbo devtools` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "在浏览器中可视化你的 monorepo 包图。"
  }, {
    "heading": "",
    "content": "¥Visualize your monorepo's package graph in the browser."
  }, {
    "heading": "",
    "content": "此命令启动本地服务器，并在浏览器中打开 monorepo 包图的可视化界面。"
  }, {
    "heading": "",
    "content": "¥This command starts a local server and opens your browser to a visualization of your monorepo's package graph."
  }, {
    "heading": "选项-options",
    "content": "¥Options"
  }, {
    "heading": "--port---port",
    "content": "运行 devtools 服务器的端口。默认为 9876。"
  }, {
    "heading": "--port---port",
    "content": "¥The port to run the devtools server on. Defaults to 9876."
  }, {
    "heading": "--no-open---no-open",
    "content": "服务器启动时不自动打开浏览器。"
  }, {
    "heading": "--no-open---no-open",
    "content": "¥Do not automatically open the browser when the server starts."
  }],
  "headings": [{
    "id": "选项-options",
    "content": "选项 /*options*/"
  }, {
    "id": "--port---port",
    "content": "--port /*--port*/"
  }, {
    "id": "--no-open---no-open",
    "content": "--no-open /*--no-open*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#选项-options",
  title: _jsx(_Fragment, {
    children: "选项 "
  })
}, {
  depth: 3,
  url: "#--port---port",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--port"
    }), " "]
  })
}, {
  depth: 3,
  url: "#--no-open---no-open",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--no-open"
    }), " "]
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "在浏览器中可视化你的 monorepo 包图。"
    }), "\n", _jsx(_components.p, {
      children: "¥Visualize your monorepo's package graph in the browser."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " devtools"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [options]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "此命令启动本地服务器，并在浏览器中打开 monorepo 包图的可视化界面。"
    }), "\n", _jsx(_components.p, {
      children: "¥This command starts a local server and opens your browser to a visualization of your monorepo's package graph."
    }), "\n", _jsx(_components.h2, {
      id: "选项-options",
      children: "选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Options"
    }), "\n", _jsxs(_components.h3, {
      id: "--port---port",
      children: [_jsx(_components.code, {
        children: "--port"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["运行 devtools 服务器的端口。默认为 ", _jsx(_components.code, {
        children: "9876"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The port to run the devtools server on. Defaults to ", _jsx(_components.code, {
        children: "9876"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " devtools"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --port"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3000"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--no-open---no-open",
      children: [_jsx(_components.code, {
        children: "--no-open"
      }), " "]
    }), "\n", _jsx(_components.p, {
      children: "服务器启动时不自动打开浏览器。"
    }), "\n", _jsx(_components.p, {
      children: "¥Do not automatically open the browser when the server starts."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " devtools"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --no-open"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
